import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import { FreeFieldDefinitionNewSection } from "FreeFieldDefinition/FreeFieldDefinitionNewSection";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";

const FreeFieldDefinitionNewApp = () => {
  const viewModel = useLoaderData<server.viewmodel.FreeFieldDefinitionNewFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <FreeFieldDefinitionNewSection
        mainArea={viewModel.mainArea}
        initialCategory={viewModel.freeFieldCategory}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        links={[{
          text: RESX.Buttons.ListView,
          href: viewModel.listUrl,
          visible: true
        }]}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default FreeFieldDefinitionNewApp;